import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import './DialerTermination.css';

const DialerTermination = () => {
  return (
    <div className="dialertermination-container">
      {/* Hero Section */}
      <section className="dialertermination-hero">
        <motion.div 
          className="dialertermination-hero-content"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h1 className="dialertermination-hero-title">Dialer Termination Services</h1>
          <h2 className="dialertermination-hero-subtitle">
            High-Performance Outbound Solutions for Call Centers and Enterprises
          </h2>
          <Link to="/contact" className="dialertermination-cta-btn">
            <motion.button
              className="dialertermination-cta-btn"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Get Started
            </motion.button>
          </Link>
        </motion.div>
      </section>

      {/* Main Content */}
      <section className="dialertermination-content">
        <div className="dialertermination-content-container">
          <motion.div 
            className="dialertermination-intro"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <p className="dialertermination-section-text">
              At DirectRoutes Networks, we specialize in Dialer Termination Services designed to meet the demanding needs of call centers, telemarketing firms, and enterprise-level outbound communication systems. Our scalable telecom infrastructure ensures your business remains reachable, reliable, and capable of handling high-volume campaigns efficiently.
            </p>
          </motion.div>

          <motion.div 
            className="dialertermination-why-choose-section"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
          >
            <h2 className="dialertermination-section-title">Why Choose DirectRoutes Networks?</h2>
            <h3 className="dialertermination-subsection-title">Expertise. Reach. Support.</h3>
            <p className="dialertermination-section-text">
              With extensive experience in global voice services, our team acts as your strategic partner—helping you stay connected, competitive, and fully compliant. Whether you are a service provider, call center, enterprise, or application developer, DirectRoutes Networks delivers outbound termination solutions you can trust.
            </p>
          </motion.div>

          <motion.div 
            className="dialertermination-what-we-offer-section"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.6 }}
          >
            <h2 className="dialertermination-section-title">What We Offer</h2>
          </motion.div>

          <motion.div 
            className="dialertermination-features-section"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.8 }}
          >
            <div className="dialertermination-feature-item">
              <h3 className="dialertermination-feature-title">High ASR (Answer-Seizure Ratio)</h3>
              <p className="dialertermination-feature-text">
                Maximize call connection rates with our reliable, high-quality routes.
              </p>
            </div>

            <div className="dialertermination-feature-item">
              <h3 className="dialertermination-feature-title">Low PDD (Post-Dial Delay)</h3>
              <p className="dialertermination-feature-text">
                Experience near-instant call connection with minimal delay, essential for high-volume campaigns.
              </p>
            </div>

            <div className="dialertermination-feature-item">
              <h3 className="dialertermination-feature-title">Global Coverage (A-Z Termination)</h3>
              <p className="dialertermination-feature-text">
                Access competitive, high-quality termination across all international destinations.
              </p>
            </div>

            <div className="dialertermination-feature-item">
              <h3 className="dialertermination-feature-title">Scalability & Redundancy</h3>
              <p className="dialertermination-feature-text">
                Our infrastructure scales seamlessly from 10 to 10,000 concurrent calls, ensuring consistent performance for any campaign size.
              </p>
            </div>

            <div className="dialertermination-feature-item">
              <h3 className="dialertermination-feature-title">Anti-Block Routes</h3>
              <p className="dialertermination-feature-text">
                Benefit from CLI and Non-CLI routes optimized to minimize carrier-level blocking in specific regions.
              </p>
            </div>

            <div className="dialertermination-feature-item">
              <h3 className="dialertermination-feature-title">24/7 Network Operations Center Support</h3>
              <p className="dialertermination-feature-text">
                Our expert technical team monitors and manages your traffic around the clock, keeping your operations running smoothly.
              </p>
            </div>
          </motion.div>

          <motion.div 
            className="dialertermination-conclusion"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 1.0 }}
          >
            <p className="dialertermination-section-text">
              Partner with DirectRoutes Networks to ensure your outbound communications are efficient, reliable, and optimized for high performance, giving your business a competitive edge in global voice services.
            </p>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default DialerTermination;
